var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item',{attrs:{"link-class":"d-flex flex-row"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('div',{staticClass:"dropdown-icon"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }